import type { AvailablePlatform, PlatformCategory, PlatformConnection } from '@wordpuppi/shared';

export const PLATFORM_CATEGORIES = [
  { id: 'social', label: 'Social' },
  { id: 'deployment', label: 'Deploy' },
  { id: 'storage', label: 'Storage' },
] as const;

/** A platform can belong to more than one category; a connection is still created only once. */
export function platformCategoryItems(connections: PlatformConnection[], platforms: AvailablePlatform[], category: PlatformCategory) {
  const available = platforms.filter((platform) => platform.categories.includes(category));
  const connected = new Set(connections.map((connection) => connection.platform as string));
  return {
    connections: connections.filter((connection) => {
      const info = platforms.find((platform) => platform.id === connection.platform);
      return info?.categories.length ? info.categories.includes(category) : category === 'social';
    }),
    connectable: available.filter((platform) => platform.automation_status === 'automated' && !connected.has(platform.id)),
    manual: available.filter((platform) => platform.automation_status === 'manual'),
    comingSoon: available.filter((platform) => platform.automation_status === 'coming_soon'),
  };
}
